<div class="card mb-3">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <h4 class="card-header-title">
          {{ name | translate }}
        </h4>
      </div>
      <div class="col-auto" *ngIf="options">
        <div class="form-check form-check-inline" [formGroup]="form">
          <label class="form-check-label mr-2" for="categorized">{{ 'profit-and-loss.categorized.lable' | translate }}</label>
          <input class="form-check-input" type="checkbox" id="categorized" value="true" formControlName="categorized">
        </div>
      </div>
      <div class="col-auto pl-0">
        <button class="btn btn-sm btn-outline-primary" (click)="onDownload()">csv <i class="fe fe-download"></i></button>
      </div>
    </div>
  </div>

  <div class="table-responsive is-loading-lg" *ngIf="report | async as report">
    <table class="table table-hover card-table">
      <thead>
        <tr>
          <th *ngFor="let col of report[0]; let colIdx = index" [class.text-right]="colIdx !== 0">
            <ng-container *ngIf="colIdx === 0">
              {{ 'profit-and-loss.header.category' | translate }}
            </ng-container>
            <ng-container *ngIf="colIdx !== 0">
              {{ formatYearMonth(col.key) }}
            </ng-container>
          </th>
        </tr>
      </thead>

      <tbody>
        <!-- Row -->
        <ng-container *ngFor="let row of report; let rowIdx = index">
          <tr
            *ngIf="rowIdx !== 0"
            [class.collapsed]="row[0].drilldown && !expanded.includes(rowIdx)"
            [ngClass]="{ 'drilldown text-secondary small': row[0].drilldown }"
          >
            <!-- Col -->
            <td class="text-nowrap" *ngFor="let col of row; let colIdx = index" [class.text-right]="colIdx !== 0"
              [class.font-weight-bold]="isBold(report.length, rowIdx, colIdx, col)"
              [class.text-muted]="isMuted(report.length, rowIdx, colIdx, col)"
            >
              <!-- String value -->
              <ng-container
                *ngIf="!isNumber(col.value); else valueIsNumber"
              >
                <span
                  [class.cursor-pointer]="expandableRows.includes(rowIdx)"
                  [class.pl-3]="col.drilldown && colIdx === 0"
                  (click)="!!onToggleExpanded(rowIdx)"
                >
                  {{ getValue(col) | async }} <i class="fa fa-caret-down" *ngIf="expandableRows.includes(rowIdx) && expandedRowIdx !== rowIdx; else caretUp"></i> <ng-template #caretUp><i *ngIf="expandedRowIdx === rowIdx" class="fa fa-caret-up"></i></ng-template>
                </span>
              </ng-container>

              <!-- Number value -->
              <ng-template #valueIsNumber>

                <!-- Drilldown document value -->
                <a href class="text-secondary pl-4"
                  *ngIf="col.documentId; else notDocument"
                  [routerLink]="documentLink(col)"
                  target="_blank"
                >
                  <i class="fe fe-external-link"></i> {{ col.value | pepNumber: 2: locale }}
                </a>

                <!-- Category amount value -->
                <ng-template #notDocument>{{ col.value | pepNumber: 2: locale }}</ng-template>
              </ng-template>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

